export const CREATE_NEW_EVENT = 'CREATE NEW EVENT'
export const VIEW_VIRTUAL_POWER_PLANTS = 'VIEW VIRTUAL POWER PLANTS'
export const SUBMIT_NEW_APPLICATION = 'SUBMIT NEW APPLICATION'
export const SEE_APPLICATION_WORKFLOW = 'SEE HOW APPLICATION PROCESS WORKS'
export const PROGRAM_STATUS_INACTIVE_COLOR = '#FFD800'
export const EDIT_APPLICATION = 'EDIT & RESUBMIT'
export const DOWNLOAD_APPLICATION_FORM = 'DOWNLOAD PROGRAM DOCUMENTS'
export const PROGRAM_STATUS_ACTIVE_COLOR = '#7ACF38'
